import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=c6fe0f34&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=c6fe0f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fe0f34",
  null
  
)

export default component.exports